import api from './api'
export default {
    get: function(parms) {
      return api.get('business_setup',{
        params: parms
        })
    },
    
  }